'use client';

import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from '@headlessui/react';
import { cn } from '@lib/util/cn';
import type { ContactTemplateProps } from '../../types';

type ComplaintsSectionProps = Pick<ContactTemplateProps, 'complaintsText'>;

export default function ComplaintsSection({
  complaintsText,
}: ComplaintsSectionProps) {
  const buttonBase =
    'text-sm font-bold text-fg-interactive-strong underline hover:no-underline focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-fg-interactive-strong focus-visible:ring-offset-2 rounded-sm';

  return (
    <Disclosure>
      {({ open }) => (
        <div>
          <div className="flex justify-center">
            <DisclosureButton className={cn(buttonBase, open && 'hidden')}>
              Our complaints procedure
            </DisclosureButton>
          </div>

          <DisclosurePanel
            transition
            className={cn(
              'grid transition-[grid-template-rows,opacity] duration-300 ease-in-out',
              'data-closed:grid-rows-[0fr] data-closed:opacity-0',
              'data-open:grid-rows-[1fr]',
              open && 'mt-2',
            )}
          >
            <div className="min-h-0 overflow-hidden rounded-2 bg-surface-neutral-subtle">
              <div className="flex flex-col gap-2 p-4 text-sm">
                <p className="font-bold text-fg-neutral-strong">
                  Our complaints procedure
                </p>
                <p className="text-fg-neutral-strong">{complaintsText}</p>
                <DisclosureButton
                  className={cn(buttonBase, 'mx-auto mt-2 w-fit text-center')}
                >
                  Close
                </DisclosureButton>
              </div>
            </div>
          </DisclosurePanel>
        </div>
      )}
    </Disclosure>
  );
}
